import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { Link } from 'react-router-dom';
function Chat({ name, message, profilePic, timeSpan }) {
    return (
        <Link to ={`/chats/${name}`}>
        <div className="chat">
            <Avatar className="chats_image" alt={name} src={profilePic} />
            <div className="chat_details">
                <h2>{name}</h2>
                <p>{message}</p>
            </div>
            <div className="timeSpan">
                <p>{timeSpan}</p>
            </div>
        </div>
        </Link>

    )
}

export default Chat;